import React from "react";

const click = (selector) => {
  const el = typeof selector === 'string' ? document.querySelector(selector) : selector;
  if (el) el.click();
};

export const getBuilderSteps = () => [
  {
    target: () => document.querySelector('[data-tour-id="builder-title-input"]'),
    title: "Nome do relatório",
    description: "Defina um título claro e descritivo para o relatório.",
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-description-input"]'),
    title: "Descrição",
    description: "Explique o objetivo e o contexto do relatório para o leitor.",
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-widget-list"]'),
    title: "Tipos de gráficos",
    description: "Escolha entre barras, pizza, tabela, gauge e componentes especiais.",
  },
  {
    target: () => document.querySelector('[data-tour-id="widget-verticalBar"]') || document.querySelector('[data-tour-id="widget-vertical-bar"]'),
    title: "Adicionar gráfico",
    description: "Clique para adicionar um gráfico de barras e editar no canvas.",
    nextButtonProps: { children: 'Próximo', onClick: () => click('[data-tour-id="widget-verticalBar"]') }
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-canvas"]'),
    title: "Canvas e layout",
    description: "Arraste, redimensione e posicione os componentes no grid.",
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-color-palette"]'),
    title: "Paleta de cores",
    description: "Ajuste cores dos gráficos para comunicar melhor os dados.",
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-save-template-btn"]'),
    title: "Salvar como modelo",
    description: "Salve esta configuração como um template reutilizável.",
    nextButtonProps: {
      children: 'Próximo',
      onClick: () => {
        click('[data-tour-id="builder-save-template-btn"]');
        setTimeout(() => {
          const modal = document.querySelector('[data-tour-id="builder-save-template-modal"]');
          if (modal) {
            window.dispatchEvent(new Event('tour-close-save-template-modal'));
          }
        }, 200);
      }
    }
  },
  {
    target: () => document.querySelector('[data-tour-id="builder-save-report-btn"]'),
    title: "Salvar relatório",
    description: "Persista o relatório e continue evoluindo seu conteúdo.",
  },
];